var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon_play"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.726 30.726C27.2109 34.2424 22.968 36 18 36C13.0307 36 8.78914 34.2424 5.274 30.726C1.75757 27.2109 0 22.9693 0 18C0 13.032 1.75757 8.78914 5.274 5.274C8.78914 1.75757 13.0307 0 18 0C22.968 0 27.2109 1.75757 30.726 5.274C34.2424 8.78914 36 13.032 36 18C36 22.9693 34.2424 27.2109 30.726 30.726Z",
  fill: "#4585FF",
  fillOpacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill 37",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.0859 18L13.5 25.1717V10.8283L26.0859 18ZM6.11743 29.8826C9.39857 33.165 13.3599 34.8043 18 34.8043C22.6401 34.8043 26.6001 33.165 29.8826 29.8826C33.1637 26.6014 34.8043 22.6401 34.8043 18C34.8043 13.3599 33.1637 9.39986 29.8826 6.11743C26.6001 2.83629 22.6401 1.19571 18 1.19571C13.3599 1.19571 9.39857 2.83629 6.11743 6.11743C2.835 9.39986 1.19571 13.3599 1.19571 18C1.19571 22.6401 2.835 26.6014 6.11743 29.8826ZM30.726 30.726C27.2109 34.2424 22.968 36 18 36C13.0307 36 8.78914 34.2424 5.274 30.726C1.75757 27.2109 0 22.9693 0 18C0 13.032 1.75757 8.78914 5.274 5.274C8.78914 1.75757 13.0307 0 18 0C22.968 0 27.2109 1.75757 30.726 5.274C34.2424 8.78914 36 13.032 36 18C36 22.9693 34.2424 27.2109 30.726 30.726Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  d: "M30.019 30.0188L30.0188 30.019C26.6911 33.3479 22.7026 35 18 35C13.2961 35 9.30891 33.3479 5.98124 30.019L5.98098 30.0188C2.65208 26.6911 1 22.7039 1 18C1 13.2974 2.65211 9.30888 5.98098 5.98124L5.98124 5.98098C9.30891 2.65208 13.2961 1 18 1C22.7026 1 26.6911 2.65211 30.0188 5.98098L30.019 5.98124C33.3479 9.30888 35 13.2974 35 18C35 22.7039 33.3479 26.6911 30.019 30.0188Z",
  stroke: "white",
  strokeWidth: 2
}))));
export default SvgIconPlay;